import { TENANT_CH, TENANT_FR } from 'shared/consts'
import { NEWSLETTER_MODAL_ID } from 'shared/experiments/browser/newsletterModalFR/consts'
import {
  isPageBlacklisted,
  triggerNewsletterModal,
} from 'shared/experiments/browser/newsletterModalFR/utils'
import {
  EXPERIMENT_VARIATION,
  NEWSLETTER_MODAL_CH,
  NEWSLETTER_MODAL_FR,
} from 'shared/experiments/consts'
import { getExperiments } from 'shared/experiments/utils/experiments'
import store from 'shared/store'

export default () => {
  const isNLModalShown = window.sessionStorage.getItem(NEWSLETTER_MODAL_ID)
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { tenant } = publicRuntimeConfig?.publicConfig || {}
  const {
    experiments = [],
    pageType = '',
    searchUrl,
  } = publicRuntimeConfig?.pageProperties || {}

  if (
    isPageBlacklisted(pageType) ||
    isNLModalShown ||
    ![TENANT_FR, TENANT_CH].includes(tenant) ||
    !searchUrl?.includes('uwg')
  ) {
    return
  }

  const experimentList = getExperiments(
    [NEWSLETTER_MODAL_FR, NEWSLETTER_MODAL_CH],
    experiments
  )
  const isVariant1 = experimentList.find(
    experiment => experiment.variant === EXPERIMENT_VARIATION.V1
  )
  if (isVariant1) {
    triggerNewsletterModal()
  }
}
